import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {
	/**
	 * netWork 列表
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	netWorkList( params={} ) {
		return request({
	    url: baseUrl + '/device/gateways',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * netWork 添加
	**/
	netWorkAdd(data){
		return request({
			url: baseUrl + '/device/gateways',
			method:'POST',
			data
		})
	},

	/**
	 * netWork 编辑
	**/
	netWorkEdit(id,data){
		return request({
			url: baseUrl + '/device/gateways/'+id,
			method:'PUT',
			data
		})
	},
	/**
	 * netWork 删除
	**/
	netWorkDel(id){
		return request({
			url: baseUrl + '/device/gateways/'+id,
			method:'DELETE'
		})
	},

	networkSetHome(id,data){
		return request({
			url: baseUrl + '/device/gatewaysSetHome/'+id,
			method:'POST',
			data
		})
	}
}